import { FileText, Mail } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@components/common/table";
import { DictType } from "@pma/types";
import useTranslator from "@pma/hooks/use-translator";
import { Button } from "@components/common/button";
import { Progress } from "@components/common/progress";

interface Props {
  quote: DictType;
  revalidate: CallableFunction;
}

export default function QuoteRow({ quote, revalidate }: Props) {
  const { translate } = useTranslator();

  return (
    <div className='border rounded-b-md overflow-hidden'>
      <div className='grid grid-cols-12 gap-2 p-4 items-center text-sm'>
        <div className='col-span-1'>{quote?.id}</div>

        <div className='col-span-2'>
          <div className='flex items-center'>
            <span>{quote?.title}</span>
          </div>
        </div>

        <div className='col-span-2'>
          <div className='flex flex-col'>
            <span>
              {quote?.hours}/{quote?.totalHours}
            </span>
            <span className='text-muted-foreground text-xs'>Cost: ${quote?.cost}</span>
          </div>
        </div>

        <div className='col-span-1'>
          <span className='text-xs text-muted-foreground'>{quote?.invoice}</span>
        </div>

        <div className='col-span-3'>
          <Progress value={quote?.progress} max={100} className='h-2' />
        </div>

        <div className='col-span-1'>
          <span
            className={`px-3 py-1 rounded-full text-xs ${
              quote?.status === "Paid"
                ? "bg-green-100 text-green-800"
                : quote?.status === "In Progress"
                  ? "bg-blue-100 text-blue-800"
                  : "bg-yellow-100 text-yellow-800"
            }`}
          >
            {quote?.status}
          </span>
        </div>

        <div className='col-span-2 flex justify-end space-x-2 gap-2'>
          <Button variant='outline' size='sm' className='h-8 text-primary'>
            <FileText className='h-4 w-4 mr-1' />
            {translate("Milestone")}
          </Button>

          <Button variant='outline' size='icon' className='h-8'>
            <Mail className='h-5 w-5 text-white fill-primary' />
          </Button>
        </div>
      </div>

      <div className=' p-4 border-t'>
        <h3 className='font-medium mb-2'>{translate("Quote Details")}</h3>
        <Table className='w-full text-sm'>
          <TableHeader>
            <TableRow className='border-b'>
              <TableHead className='text-left py-2 px-2'>{translate("Task")}</TableHead>
              <TableHead className='text-left py-2 px-2'>{translate("Assignee")}</TableHead>
              <TableHead className='text-left py-2 px-2'>{translate("Hours")}</TableHead>
              <TableHead className='text-left py-2 px-2'>{translate("Status")}</TableHead>
              <TableHead className='text-left py-2 px-2'>{translate("Due Date")}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {[1, 2, 3].map((task) => (
              <TableRow className='border-b' key={task}>
                <TableCell className='py-2 px-2'>Initial Setup</TableCell>
                <TableCell className='py-2 px-2'>ROG User</TableCell>
                <TableCell className='py-2 px-2'>15</TableCell>
                <TableCell className='py-2 px-2'>
                  <span className='px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs'>
                    {translate("Complete")}
                  </span>
                </TableCell>
                <TableCell className='py-2 px-2'>2025-05-05</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
